export const forceScrollToTop = (delay = 500, selector = '.app-layout') => {
  setTimeout(() => {
    const element = document.querySelector(selector);

    if (element instanceof HTMLElement) {
      element.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    }
  }, delay);
};
